import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import type { Channel } from '@t/productOffering.types';
import { ChannelLogoTooltip } from '@components/ProductOffers/misc/ChannelLogoTooltip';
import { SideModalHeader } from '@shared/components/overlays/SideModalHeader/SideModalHeader';

interface ChannelListSideModalProps {
  open: boolean;
  onClose: () => void;
  channels: Channel[];
}

export const ChannelListSideModal = ({ open, onClose, channels }: ChannelListSideModalProps) => {
  return (
    <Dialog variant="channelListDialog" open={open} onClose={onClose}>
      <SideModalHeader title="Included Channels" onClose={onClose} />
      <DialogContent>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(3, 1fr)', md: 'repeat(auto-fill, 114px)' },
            gap: '16px',
          }}
        >
          {channels.map((channel) => (
            <ChannelLogoTooltip
              key={channel.name}
              channel={channel}
              placement="top"
              logoWidth="100%"
              logoHeight="auto"
              logoBorderRadius="8px"
              wrapperSx={{ flexDirection: 'column', minHeight: 87, boxSizing: 'border-box' }}
            />
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
